export const TradeEnum = {
  MT5: "mt5",
  Lite: "lite",
  Pro: "pro",
};
